import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MainLogo from '../assets/logo/mainLogo.png';
import './Header.css';
import MenuIcon from '../assets/icon/menu.png';

const Header = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  // ESC로 닫기
  useEffect(() => {
    const onKey = (e: any) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const goToGallery = () => {
    navigate('/pages/gallery')
    setOpen(false)
  }

  const goToAbout = () => {
      navigate('/pages/about')
      setOpen(false)
  }

  const goToContact = () => {
      navigate('/pages/contact')
      setOpen(false)
  }

  return (
    <>
      <header className="header">
        <img
          onClick={() => navigate('/')}
          src={MainLogo}
          alt="logo"
          className="header__logo"
        />
        <button
          className="header__hamburger"
          aria-label="Open menu"
          aria-expanded={open}
          onClick={() => setOpen(true)}
        >
          <img src={MenuIcon} style={{width: 40, height: 40,}} />
        </button>
      </header>

      {/* 오버레이 */}
      <div
        className={`backdrop ${open ? 'backdrop--show' : ''}`}
        onClick={() => setOpen(false)}
      />

      {/* 좌측 패널 */}
      <aside
        className={`drawer ${open ? 'drawer--open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
      >
        <button className="drawer__close" onClick={() => setOpen(false)} aria-label="Close menu">×</button>
        <nav className="drawer__nav">
          <div style={{cursor: "pointer"}} onClick={() => {navigate('/'); setOpen(false) }}>홈</div>
          <div style={{cursor: "pointer"}} onClick={goToGallery}>갤러리</div>
          <div style={{cursor: "pointer"}} onClick={goToAbout}>ABOUT</div>
          <div style={{cursor: "pointer"}} onClick={goToContact}>CONTACT</div>
        </nav>
      </aside>
    </>
  );
};

export default Header;
